import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  CardContent,
  Collapse,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import {
  useGetUserInfoOnyQuery,
  useGetRequestQuery,
  useDeleteRequestMutation,
} from "../../../Api/attoDeskApi";
import { IUserAdmin, IRequest } from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import Pagination from "../../../Components/Pagination";
import { Link } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { styled } from "@mui/material/styles";
import useIsMobile from "../../../Core/hook/useIsMobile";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const isMobileRes = useIsMobile();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IRequest | null>(
    null
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const { data, isLoading, isError, refetch } = useGetRequestQuery({
    searchText: currentSearchQuery,
    id: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const emailRecordList = useMemo(() => {
    return data?.data as IRequest[];
  }, [data?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name}`);
    });
    return map;
  }, [userList]);

  const handleOpenDeletePopup = (coursingsTwo: IRequest) => {
    setCoursingToDelete(coursingsTwo);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteRequestMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Request Canceled successfullyy");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to request cancel");
      }
    } catch (error) {
      showErrorMessage("Failed to equest cancel");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IRequest[] = Array.isArray(data?.data)
    ? (data?.data as IRequest[])
    : [];

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card} sx={{ minHeight: 400 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={3}
              sx={{ padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={4}
                md={4}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>Request</Typography>
              </Grid>
              <Grid
                item
                lg={8}
                md={8}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Subject.."
                      sx={{ width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}>
                        <strong>Date</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Status</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Created By</strong>
                      </TableCell>
                      <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading || userIsLoading ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="10vh"
                          >
                            <CircularProgress />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : isError || coursings.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {isError
                            ? "Error fetching data"
                            : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      coursings
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: IRequest, index) => (
                          <TableRow
                            key={index}
                            className={classes.tableRowHover}
                          >
                            <TableCell scope="row" className={classes.tablCell}>
                              <Grid container spacing={1}>
                                <Grid
                                  item
                                  textAlign={"left"}
                                  alignContent={"center"}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {`${
                                      dayjs(row?.schedule_date).format(
                                        "MMM-D, YYYY"
                                      ) || ""
                                    }`}
                                  </Typography>
                                  <Typography
                                    className={classes.mobileListText}
                                  >
                                    {formatTime(row.startTime)} -{" "}
                                    {formatTime(row.endTime)}
                                    {row.spansNextDay == true && (
                                      <span
                                        style={{
                                          color: "#e3791a",
                                          fontWeight: 600,
                                          lineHeight: 1.5,
                                          fontSize: "0.875rem",
                                          paddingLeft: "1px",
                                        }}
                                      >
                                        [next day]
                                      </span>
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </TableCell>

                            <TableCell scope="row" className={classes.tablCell}>
                              {row?.final_status === "Active" ? (
                                <Grid container alignItems="center" spacing={1}>
                                  <Chip
                                    icon={<NotificationsActiveOutlinedIcon />}
                                    label="Active"
                                    variant="outlined"
                                    color="info"
                                    className={classes.chipButton}
                                  />
                                </Grid>
                              ) : row?.final_status === "Completed" ? (
                                <Grid container alignItems="center" spacing={1}>
                                  <Chip
                                    icon={<CheckCircleIcon />}
                                    label="Completed"
                                    variant="outlined"
                                    color="success"
                                    className={classes.chipButton}
                                  />
                                </Grid>
                              ) : row?.final_status ===
                                "Past Schedule is not complete" ? (
                                <Grid container alignItems="center" spacing={1}>
                                  <Chip
                                    icon={<CancelIcon />}
                                    label="Incomplete (Past)"
                                    variant="outlined"
                                    color="warning"
                                    className={classes.chipButton}
                                  />
                                </Grid>
                              ) : row?.final_status === "Cancel" ? (
                                <Grid container alignItems="center" spacing={1}>
                                  <Chip
                                    icon={<CancelIcon />}
                                    label="Cancel"
                                    variant="outlined"
                                    color="error"
                                    className={classes.chipButton}
                                  />
                                </Grid>
                              ) : (
                                <Grid container alignItems="center" spacing={1}>
                                  <Chip
                                    icon={<CancelIcon />}
                                    label="Failed to process the employee schedule request."
                                    variant="outlined"
                                    color="error"
                                    className={classes.chipButton}
                                  />
                                </Grid>
                              )}
                            </TableCell>
                            <TableCell scope="row" className={classes.tablCell}>
                              <Typography>{`${userMap.get(
                                row.created_by
                              )}`}</Typography>
                              <Typography>
                                {dayjs(row.created_at).format(
                                  "MMM-DD, YYYY hh:mm A"
                                )}
                              </Typography>
                            </TableCell>
                            <TableCell scope="row" className={classes.tablCell}>
                              <Grid
                                container
                                spacing={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid item>
                                  <Link
                                    to={`/request/view/${row.id}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Button
                                      // variant="contained"
                                      className={classes.viewButtonList}
                                      onClick={() =>
                                        navigate(`/request/view/${row.id}`)
                                      }
                                    >
                                      <VisibilitySharpIcon
                                        className={classes.viewListIcon}
                                      />
                                    </Button>
                                  </Link>
                                </Grid>
                                {row.status === "Active" && (
                                  <Grid item>
                                    <Button
                                      // variant="contained"
                                      className={classes.deleteButtonList}
                                      onClick={() => handleOpenDeletePopup(row)}
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                )}
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {coursingToDelete && (
                <DeletePopup
                  open={openDeleteCategory}
                  handleCloseDelete={handleCloseDeletePopup}
                  onConfirm={async () => {
                    await handleDelete(coursingToDelete.id.toString());
                  }}
                  title="Delete Request"
                  content={`Are you sure you want to delete "${
                    coursingToDelete.subject || ""
                  }"?`}
                />
              )}
              <Grid
                spacing={5}
                p={"18px"}
                py={4}
                justifyContent={"end"}
                container
                textAlign={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <Grid
                  sx={{
                    textAlign: "end",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Pagination
                    count={coursings.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
